import { CommonRootState } from '../root.reducer';

import { UI_MENU_MODAL_ID } from './constants';

export const isModalOpen = (state: CommonRootState, id: string) => !!state.ui.modal[id];

// Convenience
export const selectIsMenuModalOpen = (state: CommonRootState) => isModalOpen(state, UI_MENU_MODAL_ID);
